/** 活动状态  */
export enum ActivityStatus {
  /** 未开始 */
  // notStarted = 1,
  /** 未发布、草稿 */
  unpublished = 1,
  /** 进行中 */
  processing = 2,
  /** 终止 */
  over = 3,
  /** 暂停中 */
  suspended = 5,
  /** 审批中 */
  under_approval = 7,
  /** 未通过 */
  failed = 8,
  /** 已计划 */
  scheduled = 10,
  /** 测试进行中（仅AB活动会存在此状态） */
  test_in_progress = 11,
  /** 发送中断(占位符确实导致活动异常) */
  sending_interrupted = 12,

  /** 终止（仅展示层面，不可用于联动禁用之类操作判断） */
  terminated = 40,
  /** 剩余流量投递中（仅展示层面，不可用于联动禁用之类操作判断） */
  winner_deliveryIn_progress = 42,
  /** Test in progress (sending)（仅展示层面，不可用于联动禁用之类操作判断） */
  test_in_progress_sending = 43,
  /** Test in progress (pending winner selection)（仅展示层面，不可用于联动禁用之类操作判断） */
  test_in_progress_pending_winner_selection = 44,
  /** 排队中，禁发时间段 （仅展示层面，不可用于联动禁用之类操作判断）*/
  waitlist = 45,
}
/** 周期状态  */
export enum CycleSendState {
  /** 未开始 */
  notStarted = 0,
  /** 未发送 */
  unsent = 1,
  /** 发送中 */
  beingSent = 2,
  /** 已发送 */
  sent = 3,
}

// 进度返回参数
export interface ProgressType {
  /** 百分比 */
  percentage: string;
  /** 完成进度 */
  completeCount: string | number;
  /** 总数 */
  taskCount: string | number;
}

// 弹层信息
export type PeculiarSetupType = {
  /** 跳转来源 */
  jumpSource: string;
  /** 状态说明 */
  stateDesc?: any[];
  /** 小标题 */
  cardTitleKey?: string;
  /** 名称搜索 - placeholder */
  searchTagPlaceholderKey?: string;
  /** 详情按钮文本key */
  detailsTextKey?: string;
  /** 删除弹窗文案 */
  delDialogHeaderKey?: string;
  delDialogBodyKey?: string;
  /** 批量删除弹窗文案 */
  batchDelDialogHeaderKey?: string;
  batchDelDialogBodyKey?: string;
  /** 复制跳转链接 */
  copyPagePath?: string;
  /** 编辑跳转链接 */
  editPagePath?: string;
  /** 详情跳转链接 */
  detailsPagePath?: string;
  /** 审批详情跳转链接 */
  approvalDetailsPagePath?: string;
};
